import React, { useEffect, useState } from 'react';
type Parts = {
  d: number;
  h: number;
  m: number;
  s: number;
} | null;
export function Countdown({
  endsAt
}: {
  endsAt: string | null;
}) {
  const [parts, setParts] = useState<Parts>(() => compute(endsAt));
  useEffect(() => {
    if (!endsAt) return;
    const id = window.setInterval(() => setParts(compute(endsAt)), 1000);
    return () => window.clearInterval(id);
  }, [endsAt]);
  const units = [{
    label: 'Días',
    value: parts?.d
  }, {
    label: 'Horas',
    value: parts?.h
  }, {
    label: 'Min',
    value: parts?.m
  }, {
    label: 'Seg',
    value: parts?.s
  }];
  return <div className="flex justify-center gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-64" data-mp="324hwmk1uyshw">
      {units.map(u => <div key={u.label} className="w-[72px] rounded-2xl border border-line bg-ink py-3 text-center sm:w-20" data-id="element-65" data-mp="373kpz78h7aa1">
          <span className="block text-3xl font-black tabular-nums text-white" data-id="element-66" data-mp="10cuze0rdi1cz">
            {u.value === undefined ? '--' : String(u.value).padStart(2, '0')}
          </span>
          <span className="text-[11px] font-black uppercase tracking-widest text-muted" data-id="element-67" data-mp="y04xe63v9qs3">{u.label}</span>
        </div>)}
    </div>;
}
function compute(endsAt: string | null): Parts {
  if (!endsAt) return null;
  const diff = Math.max(0, new Date(endsAt).getTime() - Date.now());
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor(diff / 3600000 % 24),
    m: Math.floor(diff / 60000 % 60),
    s: Math.floor(diff / 1000 % 60)
  };
}